import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'antd';
import { ButtonLink, SetNameDiv } from './styled';
import CarouselHeader from './CarouselHeader';
import CarouselContent from './CarouselContent';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import AllSetsModal from './AllSetsModal';

const TypologyCarousel = ({ typologySets, headerLabel = '' }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };
  const hideModal = () => {
    setIsModalVisible(false);
  };
  const prev = () => {
    setCurrentIndex(currentIndex - 1);
  };

  const next = () => {
    setCurrentIndex(currentIndex + 1);
  };

  const currentSelectedSet = useMemo(
    () => typologySets[currentIndex],
    [typologySets, currentIndex]
  );

  if (!currentSelectedSet) {
    return <></>;
  }

  return (
    <>
      <CarouselHeader
        showModal={showModal}
        showViewAll={true}
        totalNoOfSets={typologySets.length}
        current={currentIndex + 1}
      />
      <SetNameDiv>
        <ButtonLink
          type="link"
          disabled={currentIndex === 0}
          icon={<LeftOutlined />}
          onClick={prev}
        />
        <span>Set - {currentSelectedSet.combinationName}</span>
        <ButtonLink
          type="link"
          disabled={currentIndex === typologySets.length - 1}
          icon={<RightOutlined />}
          onClick={next}
        />
      </SetNameDiv>
      <CarouselContent
        key={currentSelectedSet.combinationId}
        selectedSet={currentSelectedSet}
      />
      <Modal
        width={1000}
        visible={isModalVisible}
        onOk={hideModal}
        closable={false}
        destroyOnClose
        onCancel={hideModal}
        footer={[
          <Button key="back" onClick={hideModal}>
            Close
          </Button>
        ]}>
        <AllSetsModal headerLabel={headerLabel} typologySets={typologySets} />
      </Modal>
    </>
  );
};

TypologyCarousel.prototype = {
  typologySets: PropTypes.array,
  headerLabel: PropTypes.string
};

export default TypologyCarousel;
